/* eslint-disable max-lines */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import * as React from 'react';
import { forwardRef, useImperativeHandle } from 'react';

type ClearHandle = {
  clear: () => void;
};

const ClearEditorPlugin: React.ForwardRefRenderFunction<ClearHandle> = (_props, ref) => {
  const [editor] = useLexicalComposerContext();

  useImperativeHandle(
    ref,
    () => ({
      clear(): void {
        editor.update(() => {
          const root = $getRoot();
          root.clear();
        });
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <></>;
};

export default forwardRef(ClearEditorPlugin);
